import { useUserActions, useUserInfo } from "@/store/userStore";
import { Button } from "@/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/ui/dropdown-menu";
import { useTranslation } from "react-i18next";
import { auth } from "@/utils/firebase";
import { useAuth } from "@/components/auth/use-auth";

/**
 * Account Dropdown
 */
export default function AccountDropdown() {
	const { avatar } = useUserInfo();
	const { clearUserInfoAndToken } = useUserActions();
	const { logout: firebaseLogout } = useAuth();
	const { t } = useTranslation();
	const logout = async () => {
		try {
			await firebaseLogout();
			clearUserInfoAndToken();
		} catch (error) {
			console.log(error);
		}
	};
	const email = auth.currentUser?.email;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="rounded-full">
					<img className="h-6 w-6 rounded-full" src={avatar} alt="" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="w-56">
				<div className="flex items-center gap-2 p-2">
					<img className="h-10 w-10 rounded-full" src={avatar} alt="" />
					<div className="flex flex-col items-start">
						<div className="text-text-secondary text-xs">{email}</div>
					</div>
				</div>
				<DropdownMenuSeparator />
				<DropdownMenuItem className="font-bold text-warning" onClick={logout}>
					{t("sys.login.logout")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
